import React from 'react';
import { useScrollableContainer } from '../common/ScrollableContainer';
import { MenuButton, MenuGroupHeader } from '../GlobalNavigationBar';
import { MobileHeaderContainer, MobileHeaderNote, MobileHeaderText, MobileMenuWrapper, ScrollableContainer } from '../GlobalNavigationBar/mobile/CommonStyles';
import { MobileActionContainer } from '../GlobalNavigationBar/mobile/MobileActionContainer';

interface MobileCustomMenuContentProps {
  header?: MenuGroupHeader;
  action?: MenuButton;
  children?: React.ReactNode;
}

export const MobileCustomMenuContent: React.FunctionComponent<MobileCustomMenuContentProps> = ({ children, header, action }) => {
  const [scrollContainerRef, scrollable] = useScrollableContainer([children]);

  return (
    <MobileMenuWrapper>
      <ScrollableContainer ref={scrollContainerRef as any} className={scrollable ? 'scrollable' : ''}>
        {!!header && (
          <MobileHeaderContainer>
            <MobileHeaderText>{header.header}</MobileHeaderText>
            {header.note && <MobileHeaderNote>{header.note}</MobileHeaderNote>}
          </MobileHeaderContainer>
        )}
        {children}
      </ScrollableContainer>
      {action && <MobileActionContainer {...action} />}
    </MobileMenuWrapper>
  );
};
